<template>
  <v-card class="ma-3">
    <v-card-title>Add Topics</v-card-title>
    <v-card-text>
      <v-row class="ma-1 d-flex align-center"
        ><v-btn-toggle v-model="topicType" mandatory @change="onTp" class="mr-4"
          ><v-btn v-for="type in types" v-bind:key="type">{{
            type
          }}</v-btn></v-btn-toggle
        >
        <v-text-field v-model="topic" label="Enter topic to add"></v-text-field
        ><v-btn
          class="ml-4"
          @click="
            addTopic(
              { topic, subtopics: [], type: types[topicType], description },
              topicType ? selectedParentTopics : []
            )
          "
          >Add</v-btn
        ></v-row
      >
      <v-select
        v-show="topicType"
        v-model="selectedParentTopics"
        :items="topics"
        label="Select parent topics"
        multiple
        return-object
        single-line
        class="mx-2"
      ></v-select>
      <v-textarea v-model="description" label="Description"> </v-textarea>
      <hr />
      <hr />
      <hr />
      <v-card-title class="ml-n4">Remove Topics</v-card-title>

      <v-row class="ma-1 d-flex align-center"
        ><v-select
          v-model="selectedRemoveTopic"
          :items="topics"
          label="Select a topic to remove"
          return-object
          single-line
        ></v-select>
        <v-btn class="ml-4" @click="removeTopic(selectedRemoveTopic)"
          >Remove</v-btn
        >
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import topicsHierarchy from "../mixins/topicsHierarchy";

export default {
  name: "EditTopics",
  mixins: [topicsHierarchy],
  data: () => ({
    topic: "",
    description: "",
    selectedRemoveTopic: "",
    selectedParentTopics: "",
    types: ["primary", "subtopic"],
    topicType: 0
  }),
  computed: {
    topics() {
      return this.getTopics().map(t => t.topic);
    }
  },
  methods: {
    onTp() {
      console.log(this.topicType);
    }
  }
};
</script>

<style scoped></style>
